export default __webpack_public_path__ + "static/media/banner_welcome.4401a717.png";